<template>
    <p style="width:100%">
        <span :class="btn.css" :style="{ fontSize: btn.fontSize+'px', lineHeight: btn.lineHeight, textAlign: btn.textAlign, backgroundColor: btn.backgroundColor, color: btn.fontColor }" style="width: 100%;" v-html="btn.value"></span>
    </p>
</template>

<script>

export default {
    props: ['btn']
}    
</script>